"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('observer.stylefills', function () {
    this.items = 0;
    this.sheets = [];
    this.properties = ['min-font-size', 'max-font-size'];
    this.rules = [];
    this.running = false;
    this.init = function (items) {
        namespace_1.default.debug.showInfo('Starting global observer.stylefills');
        this.items = items;
        (0, jquery_1.default)(document).on(namespace_1.default.events.stylefills.append, this.appendSheet.bind(this));
        (0, jquery_1.default)(document).on(namespace_1.default.events.stylefills.visualDone, this.countVisuals.bind(this));
        (0, jquery_1.default)(document).on(namespace_1.default.events.stylefills.checkStyles, this.runFills.bind(this));
    };
    this.appendSheet = function (ev) {
        this.sheets.push(ev.content);
    };
    this.countVisuals = function (ev) {
        /*	Every visual sends a message, when it's client-specific stylesheets are loaded.
                When all are done we can start with the setup of the observer
        */
        this.items--;
        if (this.items === 0)
            this.setup();
    };
    this.setup = function () {
        var _this = this;
        if (namespace_1.default.params.hasStyleFills) {
            var defArr = [];
            // The style-tag that will hold all the stylefill-rules
            (0, jquery_1.default)('head').append('<style id="apaStyleFills"></style>');
            // Load all sheets and parse them for stylefill-properties
            Object.keys(this.sheets).forEach(function (sheet) {
                var tUrl = sheet + '';
                var defObj = jquery_1.default.Deferred();
                defArr.push(defObj);
                jquery_1.default.ajax({
                    url: tUrl,
                    cache: true,
                    dataType: 'text',
                    success: function (data) {
                        _this.parse(data, defObj);
                        defObj.resolve();
                    },
                    error: function () {
                        namespace_1.default.debug.showError('Stylefills encountered an error loading ' + tUrl);
                        defObj.resolve();
                    }
                });
            });
            jquery_1.default.when.apply(this, defArr).then(function (ev) { return _this.done(ev); });
        }
        else {
            namespace_1.default.debug.showInfo('Stylefills are not used in this project !!!');
            this.done();
        }
    };
    this.done = function () {
        namespace_1.default.debug.showInfo('Stylefills: setup done');
        var tEvent = jquery_1.default.Event(namespace_1.default.events.stylefills.setupDone);
        (0, jquery_1.default)(document).triggerHandler(tEvent);
    };
    this.parse = function (sheetText, defObj) {
        for (var i in this.properties) {
            var property = this.properties[i];
            var selReg = new RegExp('([^}{]+){([^}]+)?' + property.replace('-', '\\-') + '[\\s\\t]*:[\\s\\t]*([^;]+)', 'gi');
            var support = this.getRule(property);
            var selMatch;
            while (selMatch == selReg.exec(sheetText)) {
                var selections = selMatch[1].replace(/^([\s\n\r\t]+|\/\*.*?\*\/)+/, '').replace(/[\s\n\r\t]+$/, '').split(',');
                var value = selMatch[3];
                for (var j in selections) {
                    var selection = selections[j];
                    this.rules.push({
                        'selector': selection,
                        'support': support[0],
                        'rule': support[1],
                        'value': value
                    });
                }
            }
        }
        defObj.resolve();
    };
    this.getRule = function (property) {
        var propertyFunction = property.replace(/(^|-)([a-z])/g, function (m1, m2, m3) { return m3.toUpperCase(); });
        if (('Webkit' + propertyFunction) in document.body.style
            || ('Moz' + propertyFunction) in document.body.style
            || ('O' + propertyFunction) in document.body.style
            || property in document.body.style)
            return [true, propertyFunction];
        else
            return [false, propertyFunction];
    };
    this.runFills = function () {
        if (!this.running) {
            this.running = true;
            var styles = '';
            (0, jquery_1.default)('#apaStyleFills').empty();
            for (var i = 0; i < this.rules.length; i++) {
                var rule = this.rules[i];
                if (!rule.support) {
                    styles += this.fills[rule.rule](rule);
                }
            }
            (0, jquery_1.default)('#apaStyleFills').html(styles);
            this.running = false;
        }
    };
    /*		Stylefill-functions		*/
    this.fills = {
        MaxFontSize: function (rule) {
            var elements = (0, jquery_1.default)(rule.selector);
            if (elements.length > 0) {
                var element = elements[0];
                var elFontSize = parseFloat(window.getComputedStyle(element, null).getPropertyValue('font-size'));
                if (elFontSize >= parseFloat(rule.value))
                    return rule.selector + '{font-size:' + rule.value + ';}';
            }
        },
        MinFontSize: function (rule) {
            var elements = (0, jquery_1.default)(rule.selector);
            if (elements.length > 0) {
                var element = elements[0];
                var elFontSize = parseFloat(window.getComputedStyle(element, null).getPropertyValue('font-size'));
                if (elFontSize <= parseFloat(rule.value))
                    return rule.selector + '{font-size:' + rule.value + ';}';
            }
        }
    };
});
